/* eslint-disable react/no-array-index-key */
import React from 'react';

import moment from 'moment';
import PropTypes from 'prop-types';
import { Search } from '@mui/icons-material';
import { Text } from '~/components/Text';
import { Tabela } from '~/views/Client/Dashboard/Tabelas';
import { LoaderMini } from '~/components/Loaders';
import { priceFormatter } from '~/helpers/price';
import { color } from '~/assets/styles/colors';

export default function TabelaRecebimentos(props) {
	const {
		lista,
		loading,
		handlerDetalheRecebimento,
		toggleModalDetalheRecebimento,
	} = props;

	function handlerModalRecebimento(recebimento) {
		toggleModalDetalheRecebimento();
		handlerDetalheRecebimento(recebimento);
	}

	function dateSort(a, b) {
		if (a !== null && b !== null) {
			return b.data_consulta - a.data_consulta;
		}
		return null;
	}

	if (loading) {
		return (
			<div className="d-flex h-100 justify-content-center align-itens-center">
				<LoaderMini width="70" />
			</div>
		);
	}

	if (lista.length === 0) {
		return <Text>Sem resultados no periodo</Text>;
	}

	return (
		<Tabela>
			<>
				<thead>
					<tr>
						<th className="pt-2">Data</th>
						<th className="pt-2">Valor(R$)</th>
						<th className="pt-2" style={{ textAlign: 'center' }}>
							#
						</th>
					</tr>
				</thead>
				<tbody>
					{lista.sort(dateSort).map((recebimento, index) => {
						if (
							typeof recebimento === 'object' &&
							recebimento !== null
						) {
							const isToday = moment(
								recebimento.data_consulta
							).isSame(moment(), 'day');

							return (
								<tr
									key={`${recebimento.valor_bruto}-${index}`}
									style={{
										backgroundColor: isToday
											? color.secondary
											: 'transparent',
									}}>
									<td>
										{isToday ? (
											<Text weight="bold">Hoje</Text>
										) : (
											moment(
												recebimento.data_consulta
											).format('DD/MM/YYYY')
										)}
									</td>
									<td>
										{priceFormatter(
											recebimento.total_liquido
										)}
									</td>
									<td align="center">
										<div
											role="none"
											className="d-flex justify-content-center"
											onClick={() =>
												handlerModalRecebimento(
													recebimento
												)
											}
											style={{
												width: '40px',
												backgroundColor: color.yellow,
												color: color.gray,
												borderRadius: '20px',
												cursor: 'pointer',
											}}>
											<Search />
										</div>
									</td>
								</tr>
							);
						}
						return null;
					})}
				</tbody>
			</>
		</Tabela>
	);
}

TabelaRecebimentos.propTypes = {
	lista: PropTypes.oneOfType([PropTypes.array]),
	loading: PropTypes.bool.isRequired,
	handlerDetalheRecebimento: PropTypes.func.isRequired,
	toggleModalDetalheRecebimento: PropTypes.func.isRequired,
};

TabelaRecebimentos.defaultProps = {
	lista: {},
};
